const openAdminPanel = () => {
    const link = document.createElement('a');

    link.href = `${process.env.REACT_APP_LOGIN_PORTAL}/admin`;
    link.target = '_blank';
    link.click();
};

export default openAdminPanel;
